/* src/app/modules/taxes/model-193/model-193-recipients/model-193-recipients.component.css */
:host {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.r193-declarante {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 32px;
  padding: 10px 16px;
  border: 1px solid var(--cf-border);
  border-radius: var(--cf-radius);
  background: var(--cf-surface);
  font-size: 13px;
  color: var(--cf-text);
}
.r193-resumen {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}
.r193-resumen__item {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 10px 16px;
  border: 1px solid var(--cf-border);
  border-radius: var(--cf-radius);
  background: var(--cf-surface);
  font-size: 15px;
  color: var(--cf-text);
}
.r193-resumen__item--error strong {
  color: var(--cf-error);
}
.r193-resumen__label {
  font-size: 12px;
  color: var(--cf-text-muted);
}
.r193-estado {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  color: var(--cf-success);
}
.r193-estado--error {
  color: var(--cf-error);
}
.r193-estado mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.r193-filtros {
  display: flex;
  align-items: center;
  gap: 8px;
}
.r193-filtros ::ng-deep .mb-3 {
  margin-bottom: 0 !important;
}
.r193-filtros ::ng-deep app-select {
  width: 190px;
}
@media (max-width: 992px) {
  .r193-resumen {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.r193-filtros ::ng-deep .qf-search {
  height: 36px;
  width: 220px;
  padding: 0 10px;
  border: 1px solid rgba(0, 0, 0, 0.23);
  border-radius: 4px;
  background: #fff;
  font-size: 13px;
  box-sizing: border-box;
  outline: none;
}
.r193-filtros ::ng-deep .qf-search:focus {
  border-color: var(--cf-brand-dark);
}
.r193-origen {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: var(--cf-text-muted);
}
.r193-origen--manual {
  color: var(--cf-brand-dark);
  font-weight: 600;
}
.r193-origen mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
/*# sourceMappingURL=model-193-recipients.component.css.map */
